// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-header_header__pfxca {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* Responsive padding: 74px at 1536px width, scales proportionally */
    padding: 0 clamp(16px, 4.82vw, 74px);
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.7) 100%);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid #FFFFFF4D;
    z-index: 1000;
    transition: transform 0.3s ease-in-out;
}

.global-header_headerHidden__oQJWv {
    transform: translateY(-100%);
}

.global-header_headerVisible__couUk {
    transform: translateY(0);
}

/* Logo Section */
.global-header_logoSection__2zT\\+K {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.global-header_logoSection__2zT\\+K:hover {
    transform: scale(1.05);
}

.global-header_logoImage__3iKUN {
    max-height: 70%;
    height: 56px;
    width: auto;
    object-fit: contain;
}

/* Navigation Section */
.global-header_navSection__1CKbF {
    display: flex;
    align-items: center;
    gap: 16px;
}

.global-header_walletButton__iZ1o6 {
    min-width: 112px;
    height: 40px;
    padding: 0 14px 0 10px;
    border-radius: 30px;
    background: rgba(143, 227, 65, 0.12);
    border: 1.5px solid rgba(143, 227, 65, 0.45);
    color: #EAFBDC;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 14px;
    transition: all 0.25s ease;
    box-shadow: 0 4px 18px rgba(34, 197, 94, 0.16);
}

.global-header_walletButton__iZ1o6:hover {
    background: rgba(143, 227, 65, 0.2);
    border-color: rgba(143, 227, 65, 0.8);
    transform: translateY(-1px);
}

.global-header_walletIcon__6DIp2 {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    object-fit: contain;
    border-radius: 50%;
}

/* Auth Buttons */
.global-header_authButtons__dZL-x {
    display: flex;
    align-items: center;
    gap: 14px;
}

.global-header_loginButton__\\+UbuR {
    height: 40px;
    padding: 0 24px;
    border-radius: 30px;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.25s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.08);
    border: 1.5px solid rgba(255, 255, 255, 0.25);
    color: white;
    backdrop-filter: blur(4px);
}

.global-header_loginButton__\\+UbuR:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.45);
    transform: translateY(-1px);
}

.global-header_loginButton__\\+UbuR:active {
    transform: translateY(0);
}

.global-header_registerButton__vlsyO {
    width: 117px;
    height: 40px;
    padding: 0;
    border-radius: 30px;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.25s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: linear-gradient(90deg, #DA2612 0%, #9DD102 100%);
    border: none;
    color: white;
    box-shadow: 0 4px 18px rgba(185, 100, 10, 0.35);
}

.global-header_registerButton__vlsyO:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(185, 100, 10, 0.5);
    filter: brightness(1.08);
}

.global-header_registerButton__vlsyO:active {
    transform: translateY(0);
}

.global-header_authIcon__OqD1s {
    font-size: 15px;
}

/* Profile Button */
.global-header_profileButton__\\+E1IW {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background:
        conic-gradient(#FFAB00 var(--level-progress, 0%), rgba(255, 255, 255, 0.18) 0),
        linear-gradient(135deg, #131724, #252B3D);
    border: none;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: 0 4px 18px rgba(255, 171, 0, 0.24);
    padding: 3px;
}

.global-header_profileButton__\\+E1IW:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 22px rgba(255, 171, 0, 0.36);
}

.global-header_profileLevelRing__mDIDX {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: radial-gradient(circle at 35% 30%, #3B455D, #111622 70%);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.18);
    overflow: hidden;
}

.global-header_profileIcon__4G4J\\+ {
    font-size: 18px;
}

.global-header_profileImage__I\\+oWh {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    display: block;
}

.global-header_profileLevelBadge__ODFsI {
    position: absolute;
    right: -6px;
    bottom: -5px;
    min-width: 19px;
    height: 19px;
    padding: 0 5px;
    border-radius: 999px;
    background: linear-gradient(135deg, #FFAB00, #9DD102);
    border: 2px solid #0D1018;
    color: #050505;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: 'Inter', sans-serif;
    font-size: 10px;
    font-weight: 900;
    line-height: 1;
}

/* Responsive - Large screens (1536px and above) */
@media (min-width: 1536px) {
    .global-header_header__pfxca {
        padding: 0 74px;
    }
}

/* Responsive - Medium screens */
@media (max-width: 768px) {
    .global-header_header__pfxca {
        padding: 0 20px;
    }

    .global-header_logoImage__3iKUN {
        height: 48px;
    }

    .global-header_loginButton__\\+UbuR {
        height: 36px;
        padding: 0 18px;
        font-size: 13px;
    }

    .global-header_registerButton__vlsyO {
        width: 100px;
        height: 36px;
        font-size: 13px;
    }

    .global-header_authIcon__OqD1s {
        display: none;
    }

    .global-header_profileButton__\\+E1IW {
        width: 36px;
        height: 36px;
    }

    .global-header_profileLevelBadge__ODFsI {
        right: -7px;
        bottom: -6px;
        min-width: 18px;
        height: 18px;
        font-size: 9px;
    }

    .global-header_walletButton__iZ1o6 {
        min-width: 92px;
        height: 36px;
        font-size: 13px;
        padding: 0 10px 0 8px;
    }

    .global-header_walletIcon__6DIp2 {
        width: 22px;
        height: 22px;
    }
}

/* Responsive - Small screens */
@media (max-width: 480px) {
    .global-header_header__pfxca {
        padding: 0 14px;
    }

    .global-header_authButtons__dZL-x {
        gap: 10px;
    }

    .global-header_loginButton__\\+UbuR {
        padding: 0 14px;
        font-size: 12px;
    }

    .global-header_registerButton__vlsyO {
        width: 90px;
        font-size: 12px;
    }

    .global-header_walletButton__iZ1o6 {
        min-width: 78px;
        font-size: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/UI/common/Layout/global-header.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oEAAoE;IACpE,oCAAoC;IACpC,mFAAmF;IACnF,2BAA2B;IAC3B,kCAAkC;IAClC,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,oCAAoC;IACpC,4CAA4C;IAC5C,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,qCAAqC;IACrC,6CAA6C;IAC7C,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,4DAA4D;IAC5D,YAAY;IACZ,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;;iDAE6C;IAC7C,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,8CAA8C;IAC9C,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oEAAoE;IACpE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,qDAAqD;IACrD,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,kDAAkD;AAClD;IACI;QACI,eAAe;IACnB;AACJ;;AAEA,gCAAgC;AAChC;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,+BAA+B;AAC/B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;AACJ","sourcesContent":[".header {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 80px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    /* Responsive padding: 74px at 1536px width, scales proportionally */\n    padding: 0 clamp(16px, 4.82vw, 74px);\n    background: linear-gradient(180deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.7) 100%);\n    backdrop-filter: blur(10px);\n    border-bottom: 1px solid #FFFFFF4D;\n    z-index: 1000;\n    transition: transform 0.3s ease-in-out;\n}\n\n.headerHidden {\n    transform: translateY(-100%);\n}\n\n.headerVisible {\n    transform: translateY(0);\n}\n\n/* Logo Section */\n.logoSection {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n}\n\n.logoSection:hover {\n    transform: scale(1.05);\n}\n\n.logoImage {\n    max-height: 70%;\n    height: 56px;\n    width: auto;\n    object-fit: contain;\n}\n\n/* Navigation Section */\n.navSection {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.walletButton {\n    min-width: 112px;\n    height: 40px;\n    padding: 0 14px 0 10px;\n    border-radius: 30px;\n    background: rgba(143, 227, 65, 0.12);\n    border: 1.5px solid rgba(143, 227, 65, 0.45);\n    color: #EAFBDC;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    font-family: 'Inter', sans-serif;\n    font-weight: 700;\n    font-size: 14px;\n    transition: all 0.25s ease;\n    box-shadow: 0 4px 18px rgba(34, 197, 94, 0.16);\n}\n\n.walletButton:hover {\n    background: rgba(143, 227, 65, 0.2);\n    border-color: rgba(143, 227, 65, 0.8);\n    transform: translateY(-1px);\n}\n\n.walletIcon {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n    object-fit: contain;\n    border-radius: 50%;\n}\n\n/* Auth Buttons */\n.authButtons {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.loginButton {\n    height: 40px;\n    padding: 0 24px;\n    border-radius: 30px;\n    font-family: 'Inter', sans-serif;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    background: rgba(255, 255, 255, 0.08);\n    border: 1.5px solid rgba(255, 255, 255, 0.25);\n    color: white;\n    backdrop-filter: blur(4px);\n}\n\n.loginButton:hover {\n    background: rgba(255, 255, 255, 0.15);\n    border-color: rgba(255, 255, 255, 0.45);\n    transform: translateY(-1px);\n}\n\n.loginButton:active {\n    transform: translateY(0);\n}\n\n.registerButton {\n    width: 117px;\n    height: 40px;\n    padding: 0;\n    border-radius: 30px;\n    font-family: 'Inter', sans-serif;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    background: linear-gradient(90deg, #DA2612 0%, #9DD102 100%);\n    border: none;\n    color: white;\n    box-shadow: 0 4px 18px rgba(185, 100, 10, 0.35);\n}\n\n.registerButton:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 24px rgba(185, 100, 10, 0.5);\n    filter: brightness(1.08);\n}\n\n.registerButton:active {\n    transform: translateY(0);\n}\n\n.authIcon {\n    font-size: 15px;\n}\n\n/* Profile Button */\n.profileButton {\n    position: relative;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background:\n        conic-gradient(#FFAB00 var(--level-progress, 0%), rgba(255, 255, 255, 0.18) 0),\n        linear-gradient(135deg, #131724, #252B3D);\n    border: none;\n    color: white;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    box-shadow: 0 4px 18px rgba(255, 171, 0, 0.24);\n    padding: 3px;\n}\n\n.profileButton:hover {\n    transform: scale(1.1);\n    box-shadow: 0 6px 22px rgba(255, 171, 0, 0.36);\n}\n\n.profileLevelRing {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background: radial-gradient(circle at 35% 30%, #3B455D, #111622 70%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    overflow: hidden;\n}\n\n.profileIcon {\n    font-size: 18px;\n}\n\n.profileImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n    display: block;\n}\n\n.profileLevelBadge {\n    position: absolute;\n    right: -6px;\n    bottom: -5px;\n    min-width: 19px;\n    height: 19px;\n    padding: 0 5px;\n    border-radius: 999px;\n    background: linear-gradient(135deg, #FFAB00, #9DD102);\n    border: 2px solid #0D1018;\n    color: #050505;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Inter', sans-serif;\n    font-size: 10px;\n    font-weight: 900;\n    line-height: 1;\n}\n\n/* Responsive - Large screens (1536px and above) */\n@media (min-width: 1536px) {\n    .header {\n        padding: 0 74px;\n    }\n}\n\n/* Responsive - Medium screens */\n@media (max-width: 768px) {\n    .header {\n        padding: 0 20px;\n    }\n\n    .logoImage {\n        height: 48px;\n    }\n\n    .loginButton {\n        height: 36px;\n        padding: 0 18px;\n        font-size: 13px;\n    }\n\n    .registerButton {\n        width: 100px;\n        height: 36px;\n        font-size: 13px;\n    }\n\n    .authIcon {\n        display: none;\n    }\n\n    .profileButton {\n        width: 36px;\n        height: 36px;\n    }\n\n    .profileLevelBadge {\n        right: -7px;\n        bottom: -6px;\n        min-width: 18px;\n        height: 18px;\n        font-size: 9px;\n    }\n\n    .walletButton {\n        min-width: 92px;\n        height: 36px;\n        font-size: 13px;\n        padding: 0 10px 0 8px;\n    }\n\n    .walletIcon {\n        width: 22px;\n        height: 22px;\n    }\n}\n\n/* Responsive - Small screens */\n@media (max-width: 480px) {\n    .header {\n        padding: 0 14px;\n    }\n\n    .authButtons {\n        gap: 10px;\n    }\n\n    .loginButton {\n        padding: 0 14px;\n        font-size: 12px;\n    }\n\n    .registerButton {\n        width: 90px;\n        font-size: 12px;\n    }\n\n    .walletButton {\n        min-width: 78px;\n        font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `global-header_header__pfxca`,
	"headerHidden": `global-header_headerHidden__oQJWv`,
	"headerVisible": `global-header_headerVisible__couUk`,
	"logoSection": `global-header_logoSection__2zT+K`,
	"logoImage": `global-header_logoImage__3iKUN`,
	"navSection": `global-header_navSection__1CKbF`,
	"walletButton": `global-header_walletButton__iZ1o6`,
	"walletIcon": `global-header_walletIcon__6DIp2`,
	"authButtons": `global-header_authButtons__dZL-x`,
	"loginButton": `global-header_loginButton__+UbuR`,
	"registerButton": `global-header_registerButton__vlsyO`,
	"authIcon": `global-header_authIcon__OqD1s`,
	"profileButton": `global-header_profileButton__+E1IW`,
	"profileLevelRing": `global-header_profileLevelRing__mDIDX`,
	"profileIcon": `global-header_profileIcon__4G4J+`,
	"profileImage": `global-header_profileImage__I+oWh`,
	"profileLevelBadge": `global-header_profileLevelBadge__ODFsI`
};
export default ___CSS_LOADER_EXPORT___;
